module.exports = __webpack_public_path__ + "media/images/user/logo_black-c7a4dff44fe798ee5d9f6d7656c0ac6c.svg";